import BaseSvg, { BaseSVGProps } from '../BaseSVG'

export const VerticalMenuIcon = (props: BaseSVGProps) => {
  return (
    <BaseSvg {...props} viewBox="0 0 16 16">
      <path
        d="M7.9987 8.66663C8.36689 8.66663 8.66536 8.36815 8.66536 7.99996C8.66536 7.63177 8.36689 7.33329 7.9987 7.33329C7.63051 7.33329 7.33203 7.63177 7.33203 7.99996C7.33203 8.36815 7.63051 8.66663 7.9987 8.66663Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9987 3.99996C8.36689 3.99996 8.66536 3.70148 8.66536 3.33329C8.66536 2.9651 8.36689 2.66663 7.9987 2.66663C7.63051 2.66663 7.33203 2.9651 7.33203 3.33329C7.33203 3.70148 7.63051 3.99996 7.9987 3.99996Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9987 13.3333C8.36689 13.3333 8.66536 13.0348 8.66536 12.6666C8.66536 12.2984 8.36689 12 7.9987 12C7.63051 12 7.33203 12.2984 7.33203 12.6666C7.33203 13.0348 7.63051 13.3333 7.9987 13.3333Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvg>
  )
}
